import { BookMarkedIcon } from 'lucide-react';

import { DetailRowSpec } from './DetailsRow';
import { KnowledgeSearchRow, useKnowledgeSources } from './DocumentsMatched';
import { ConversationTurn } from '../../../types/conversation';

export const useKnowledgeBaseRows = (turn: ConversationTurn): DetailRowSpec[] => {
  const { collectionId } = useKnowledgeSources(turn);

  if (!collectionId) {
    return [];
  }

  return [
    {
      key: 'knowledge-base',
      icon: <BookMarkedIcon className="h-4 w-4" />,
      head: <KnowledgeSearchRow turn={turn} />,
    },
  ];
};
